import { createContext, MutableRefObject, useContext } from "react";

import { LibSvgRenderer } from "features/engine2D/svgRenderer/LibSvgRenderer";

export const MarkerRendererContext = createContext<MutableRefObject<LibSvgRenderer | null>>({
    current: null,
});

export function useMarkerRenderer() {
    return useContext(MarkerRendererContext);
}
